import { css } from '@emotion/css';

// Uses the V2 tooltip palette (navy on white) — theme-stable.
// `&&&` triples the class selector -> (0,3,0), keeping tooltip chrome
// ahead of scoped database viewport theme boundaries.
export const dragTooltipStyle = css({
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 9999,
  fontFamily: 'var(--streamlain-font-family)',
  fontSize: 'var(--streamlain-font-sm)',
  lineHeight: '1.4',
  padding: '6px 10px',
  borderRadius: '4px',
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  boxShadow: 'var(--streamlain-v2-shadow-level2)',
  whiteSpace: 'nowrap',

  '&&&': {
    background: 'var(--streamlain-v2-tooltips-background)',
    color: 'var(--streamlain-v2-tooltips-foreground)',
  },

  // Children (date + duration divs) need the same foreground even if a
  // nested theme boundary is introduced later.
  '&&& *': {
    color: 'var(--streamlain-v2-tooltips-foreground)',
  },

  // The warn row wants a different color — let it win via its own
  // triple-class rule (see dragTooltipWarnStyle).
});

export const dragTooltipWarnStyle = css({
  fontWeight: 500,

  '&&&': {
    color: 'var(--streamlain-v2-status-warning)',
  },
});
